// src/components/MetaTagsUpdater.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Define metadata for different routes
const metaData = {
  "/client": {
    title: "KinOS | AI-Powered Holistic Health & Wellness App",
    description: "KinOS is your AI-powered companion for holistic health. Track nutrition, fitness, and mindfulness, connect with a supportive community, and unlock personalized insights to achieve balanced well-being.",
    ogTitle: "KinOS – Your AI-Powered Holistic Health Companion",
    ogDescription: "Track nutrition, mindfulness, and fitness with an AI coach. Join a community of wellness seekers and stay motivated on your journey.",
    keywords: "KinOS, AI health app, holistic health, AI coach, meal tracking, mindfulness, journaling, health community, wellness tracking, well-being",
    ogUrl: "https://usekinos.com/client"
  },
  "/": {
    title: "Kinos | AI Lead Generation & Growth Engine for Solo Pros & SMBs",
    description: "Kinos is the AI-powered platform to generate more leads and supercharge your business. Automate content, capture leads, and grow—all from one simple dashboard.",
    ogTitle: "Kinos – AI Lead Generation & Growth for Solo Pros & SMBs",
    ogDescription: "Kinos helps solo pros and small businesses automate lead generation, follow-ups, and marketing—no team required.",
    keywords: "Kinos, AI lead generation, AI marketing tool, solo entrepreneurs, business growth, freelancers, small business, client automation, SMB marketing",
    ogUrl: "https://usekinos.com/"
  },
  "/privacy-policy": {
    title: "Privacy Policy | KinOS",
    description: "Learn about how KinOS collects, uses, and protects your personal information.",
    ogTitle: "Privacy Policy | KinOS",
    ogDescription: "Learn more about how KinOS collects, uses, and protects your personal information.",
    keywords: "privacy policy, data protection, user privacy, KinOS privacy",
    ogUrl: "https://usekinos.com/privacy-policy"
  },
  "/ht_phyt": {
    title: "Coach HT | The PHYT Gym – Nutrition & Fitness Coach",
    description: "Meet Coach HT, founder of The PHYT Gym. Specializing in nutrition, fitness, and women's health. Book a consultation and join the PHYT community.",
    ogTitle: "Coach HT – Nutrition & Fitness Coach | The PHYT Gym",
    ogDescription: "Transform your health with Coach HT. Expert in nutrition, fitness, and pre/post-natal training. Discover programs, testimonials, and more.",
    keywords: "Coach HT, PHYT Gym, nutrition coach, fitness, women's health, pre-natal, post-natal, Los Angeles, personal trainer",
    ogUrl: "https://usekinos.com/ht_phyt",
    ogImage: "/coach_ht.png",
    themeColor: "#7c3aed"
  }
};

function MetaTagsUpdater() {
  const location = useLocation();
  
  useEffect(() => {
    const path = location.pathname;
    
    // Get metadata for current route (default to homepage if route not found)
    const currentMeta = metaData[path] || metaData["/"];
    
    // Update document title
    document.title = currentMeta.title;
    
    // Update meta tags
    const metaTags = {
      description: document.querySelector('meta[name="description"]'),
      keywords: document.querySelector('meta[name="keywords"]'),
      ogTitle: document.querySelector('meta[property="og:title"]'),
      ogDescription: document.querySelector('meta[property="og:description"]'),
      ogUrl: document.querySelector('meta[property="og:url"]'),
      twitterTitle: document.querySelector('meta[name="twitter:title"]'),
      twitterDescription: document.querySelector('meta[name="twitter:description"]'),
      ogImage: document.querySelector('meta[property="og:image"]'),
      themeColor: document.querySelector('meta[name="theme-color"]')
    };
    
    // Update each meta tag if it exists
    if (metaTags.description) metaTags.description.setAttribute("content", currentMeta.description);
    if (metaTags.keywords) metaTags.keywords.setAttribute("content", currentMeta.keywords);
    if (metaTags.ogTitle) metaTags.ogTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.ogDescription) metaTags.ogDescription.setAttribute("content", currentMeta.ogDescription);
    if (metaTags.ogUrl) metaTags.ogUrl.setAttribute("content", currentMeta.ogUrl);
    if (metaTags.twitterTitle) metaTags.twitterTitle.setAttribute("content", currentMeta.ogTitle);
    if (metaTags.twitterDescription) metaTags.twitterDescription.setAttribute("content", currentMeta.ogDescription);
    
    // Set og:image and theme-color for /ht_phyt
    if (path === "/ht_phyt") {
      if (metaTags.ogImage) {
        metaTags.ogImage.setAttribute("content", currentMeta.ogImage);
      } else {
        const ogImg = document.createElement('meta');
        ogImg.setAttribute('property', 'og:image');
        ogImg.setAttribute('content', currentMeta.ogImage);
        document.head.appendChild(ogImg);
      }
      if (metaTags.themeColor) {
        metaTags.themeColor.setAttribute("content", currentMeta.themeColor);
      } else {
        const theme = document.createElement('meta');
        theme.setAttribute('name', 'theme-color');
        theme.setAttribute('content', currentMeta.themeColor);
        document.head.appendChild(theme);
      }
    }
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
}

export default MetaTagsUpdater;